{
  "title": "Agregar miembro del hogar",
  "client": "Cliente",
  "relationship": "Relación",
  "relationshipTo": "Relación con {{whom}} (miembro principal)",
  "alreadyMemberOf": "El cliente ya es miembro de",
  "thisHousehold": "este hogar",
  "anotherHousehold": "otro hogar",
  "memberSummary": "Resumen del miembro",
  "pleaseReview": "Revise su información para asegurarse de que sea correcta.",
  "name": "Nombre",
  "dateOfBirth": "Fecha de nacimiento",
  "continue": "Continuar",
  "added": "{{memberName}} ha sido agregado a este hogar",
  "failed": "Error al agregar un nuevo miembro.",
  "done": "Hecho",
  "createNewClient": "Crear nuevo cliente",
  "accessType": "Permisos",
  "establishedDate": "Fecha de creación"
}
